import { styled } from "@mui/material";

import { StatusTimelineSkeleton } from "./StatusTimeline";
import {
  TimelineRecordListSkeleton,
  TimelineRecordSkeleton,
} from "./TimelineRecord";

export interface TimelineSkeletonProps {
  "data-testid"?: string;
}

export function TimelineSkeleton({
  "data-testid": dataTestId,
}: TimelineSkeletonProps) {
  return (
    <Wrapper data-testid={dataTestId}>
      <StatusTimelineSkeleton />
      <TimelineRecordListSkeleton>
        <TimelineRecordSkeleton />
        <TimelineRecordSkeleton />
      </TimelineRecordListSkeleton>
    </Wrapper>
  );
}

const Wrapper = styled("div")({
  display: "flex",
});
